import $ from 'jquery';

export const init = () => {

	const $searching = $('.f-search');

	const openSearch = function() {
		$searching.addClass('is-visible');
		$searching.find('.js-search__inp').focus();

		$('.header').removeClass('is-open');

		$(document).on('click', 'html', searchCloser);
	};

	const closeSearch = function() {
		$searching.removeClass('is-visible');

		$(document).off('click', 'html', searchCloser);
	};

	const searchCloser = function(e) {
		if (!$(e.target).closest('.f-search').length) {
			e.preventDefault();

			closeSearch();
		}
	}

	$(document)
		.on('click', '.js-search', function(e) {
			e.preventDefault();

			if ($searching.hasClass('is-visible')) {
				closeSearch();
			}
			else {
				openSearch();
			}
			
		})

		.on('keyup', '.js-search__inp', function(e) {

			if (e.which == 27) {
				e.preventDefault();

				closeSearch();
			}
		});

};



// WEBPACK FOOTER //
// ./src/js/components/search.js